<template>
  <label class="checkbox-custom">
    <input
      type="checkbox"
      :value="val"
      :true-value="trueValue"
      :false-value="falseValue"
      v-model="checked"
      :disabled="disabled"
      @change="$emit('input', checkedComp)"
      @click="clicar"
      @blur="$emit('blur')"
      @focus="$emit('focus')"/>
    <div class="custom-check"></div>
    <span v-if="label">{{ label }}</span>
  </label>
</template>

<script>
export default {
  name: 'CheckBoxCustom',
  props: {
    trueValue: {
      type: [String, Number, Boolean],
      default: 'S',
    },
    falseValue:  {
      type: [String, Number, Boolean],
      default: 'N',
    },
    value: [String, Number, Array, Object, Boolean],
    label: String,
    val: [String, Number, Object, Array, Boolean],
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      checkedComp: false,
    };
  },
  methods: {
    clicar(event) {
      // event.target.blur();
      this.$emit('click');
    },
  },
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(val) {
        this.checkedComp = val;
      },
    },
  },
};
</script>

<style lang="scss">
$corPadrao: #01848c;

.checkbox-custom{
  margin: 2px 0px 2px 0px;

  &> input{
    width: 0;
    height: 0;
    opacity: 0;

    &:checked{
      &~ .custom-check{
        border-color: #008c7f!important;
        background: $corPadrao!important;

        &:after{
          content: '';
          display: block;
        }
      }
    }

    &:disabled{
      &~ .custom-check{
        border-color: rgb(160, 160, 160)!important;
        background-color: #d6d6d6!important;
        cursor: initial!important;
      }
      &:checked ~ .custom-check{
        background-color: rgb(160, 160, 160)!important;
      }
    }

    &:focus ~ .custom-check:before {
      content: '';
    }
  }

  .custom-check{
    width: 18px;
    height: 18px;
    border: 2px solid rgba(0,0,0,.54);
    border-radius: 3px;
    display: inline-flex;
    -webkit-transition: all 0.4s ease-out;
    -moz-transition: all 0.4s ease-out;
    -o-transition: all 0.4s ease-out;
    transition: all 0.4s ease-out;
    position: relative;
    cursor: pointer;

    &:after{
      position: absolute;
      height: 7px;
      width: 12px;
      border-left: 2px solid;
      border-bottom: 2px solid;
      border-color: #fff;
      display: none;
      transform: rotate(-45deg) scaleX(1) translateX(-8%) translateY(23%);
    }

    &:before {
      width: 28px;
      height: 28px;
      background-color: $corPadrao;
      display: block;
      opacity: .3;
      border-radius: 50%;
      transform: translateX(-25%) translateY(-25%);
      position: absolute;
      //-moz-transform: translateX(-21%) translateY(-21%);
      //-webkit-transform: translateX(-21%) translateY(-21%);
    }
  }

  span{
    margin-left: 5px;
    vertical-align: text-bottom;
  }
}
</style>
